import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'

export default function Modal({isOpen, setIsOpen, title, content, buttonText, maxWidth}) {
    let modalMaxWidth = maxWidth ? maxWidth : 'max-w-[900px]'
    return (
        <Transition.Root show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[20]" onClose={setIsOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity z-[10]" />
                </Transition.Child>

                <div className={`fixed inset-0 z-[20] ${modalMaxWidth} mx-auto overflow-y-auto`}>
                    <div className="flex min-h-full items-end justify-center p-4 sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:p-6">
                                <div>
                                    <div>
                                        <Dialog.Title as="h3" className="text-xl font-medium leading-6">
                                            {title ? title : 'Title'}
                                        </Dialog.Title>
                                        <div className="mt-2">
                                            {content ? content : 'Content'}
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-5 sm:mt-6">
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded border border-transparent bg-green-100 px-4 py-2 pt-3 font-bold uppercase text-xs text-white hover:bg-green-100/95 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                        onClick={() => setIsOpen(false)}
                                    >
                                        {buttonText ? buttonText : 'Close'}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
